<template>
  <div class="content create_report_step">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <ul class="status_panel">
          <li :class="{ active: repFormat }">
            <span>Step 1</span>
            Select a Report Format
          </li>
          <li :class="{ active: hasData }">
            <span>Step 2</span>
            Define Your Inputs
          </li>
          <li :class="{ active: paraData }">
            <span>Step 3</span>
            Choose Report Parameters
          </li>
        </ul>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-100" v-if="repCard">
        <h1 class="section_header">Select a Report Format</h1>
        <div class="md-layout report_card_grp">
          <div class="md-layout-item md-medium-size-50 md-size-25 p-4">
            <div :class="isFinancial ? 'report_card' : 'report_card non-subscriber no-click'">
              <div class="card_header">
                <div class="card_icon">
                  <md-icon>business_center</md-icon>
                </div>
                <h4>Financial Report</h4>
              </div>
              <div class="card_content">
                <div class="card_title">
                  <h3>Benchmark Financials</h3>
                  <md-icon>info</md-icon>
                  <div class="card_info">
                    Pellentesque habitant morbi tristique
                    senectus et netus et malesuada fames ac
                    turpis egestas. Donec vestibulum sit
                    amet felis sit amet accumsan. Sed odio
                    lacus, varius vel augue vitae, pretium
                    porta est.
                  </div>
                </div>
                <h5>Includes:</h5>
                <ul>
                  <li>
                    <i class="md-icon">check_circle</i>US and Local
                  </li>
                  <li>
                    <i class="md-icon">check_circle</i>Sole Proprietorship
                  </li>
                  <li>
                    <i class="md-icon">check_circle</i>Valuation Multiples
                  </li>
                </ul>
              </div>
              <div class="card_footer">
                <md-button class="md-block md-round"
                           @click="repCategory(constants.reportType.financial)">
                  <md-icon class="md-icon">search</md-icon>Start Analysis
                </md-button>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-50 md-size-25 p-4">
            <div :class="isMarket ? 'report_card' : 'report_card non-subscriber no-click'">
              <div class="card_header">
                <div class="card_icon">
                  <md-icon>insights</md-icon>
                </div>
                <h4>Market Report</h4>
              </div>
              <div class="card_content">
                <div class="card_title">
                  <h3>Benchmark Market Data</h3>
                  <md-icon>info</md-icon>
                  <div class="card_info">
                    Pellentesque habitant morbi tristique
                    senectus et netus et malesuada fames ac
                    turpis egestas. Donec vestibulum sit
                    amet felis sit amet accumsan. Sed odio
                    lacus, varius vel augue vitae, pretium
                    porta est.
                  </div>
                </div>
                <h5>Includes:</h5>
                <ul>
                  <li>
                    <i class="md-icon">check_circle</i>Competitive Market Narratives
                  </li>
                  <li>
                    <i class="md-icon">check_circle</i>Vestimates
                  </li>
                  <li>
                    <i class="md-icon">check_circle</i>Demographics
                  </li>
                </ul>
              </div>
              <div class="card_footer">
                <md-button class="md-block md-round" @click="repCategory(constants.reportType.market)">
                  <md-icon class="md-icon">search</md-icon>Start Analysis
                </md-button>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-50 md-size-25 p-4">
            <div :class="isValuationReport ? 'report_card' : 'report_card non-subscriber no-click'">
              <div class="card_header">
                <div class="card_icon">
                  <md-icon>attach_money</md-icon>
                </div>
                <h4>Valuation Report</h4>
              </div>
              <div class="card_content">
                <div class="card_title">
                  <h3>Analyze Business Valuation Data</h3>
                  <md-icon>info</md-icon>
                  <div class="card_info">
                    Pellentesque habitant morbi tristique
                    senectus et netus et malesuada fames ac
                    turpis egestas. Donec vestibulum sit
                    amet felis sit amet accumsan. Sed odio
                    lacus, varius vel augue vitae, pretium
                    porta est.
                  </div>
                </div>
                <h5>Includes:</h5>
                <ul>
                  <li>
                    <i class="md-icon">check_circle</i>Vestimate Pro
                  </li>
                </ul>
              </div>
              <div class="card_footer">
                <md-button class="md-block md-round"
                           @click="repCategory(constants.reportType.valuation)">
                  <md-icon class="md-icon">search</md-icon>Start Analysis
                </md-button>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-50 md-size-25 p-4">
            <div :class="isCompanyReport ? 'report_card' : 'report_card non-subscriber no-click'">
              <div class="card_header">
                <div class="card_icon">
                  <md-icon>apartment</md-icon>
                </div>
                <h4>Company Report</h4>
              </div>
              <div class="card_content">
                <div class="card_title">
                  <h3>Benchmark Company Performance</h3>
                  <md-icon>info</md-icon>
                  <div class="card_info">
                    Pellentesque habitant morbi tristique
                    senectus et netus et malesuada fames ac
                    turpis egestas. Donec vestibulum sit
                    amet felis sit amet accumsan. Sed odio
                    lacus, varius vel augue vitae, pretium
                    porta est.
                  </div>
                </div>
                <h5>Includes:</h5>
                <ul>
                  <li>
                    <i class="md-icon">check_circle</i>SWOT-EXPRESS
                  </li>
                </ul>
              </div>
              <div class="card_footer">
                <md-button class="md-block md-round" @click="repCategory(constants.reportType.company)">
                  <md-icon class="md-icon">search</md-icon>Start Analysis
                </md-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-100" v-if="repType">
        <h1 class="section_header">Define Your Inputs for {{ repFormat.title }}</h1>
        <div class="md-layout-item">
          <div class="report_type crt-rprt">

            <PulseLoader :loading="isLoading" :class="{ hide: !isLoading }"
                         quote="Action is the foundational key to all success" author="Pablo Picasso"
                         profession="Spanish Painter" img="picasso.jpg"></PulseLoader>
            <my-data-table @get-load="getLoad" />
          </div>
        </div>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-100" v-if="repPara">
        <h1 class="section_header">Choose Report Parameters of {{ repFormat.title }}</h1>
        <div class="md-layout-item">
          <div class="report_parameter">
            <new-profile :dataId="this.myData.id" :isCSV="this.isCSV" :file="this.file"
                         v-if="repFormat.value === this.constants.reportType.financial.value"
                         :financeData="this.reportData" />
            <new-market-profile :dataId="this.myData.id" :marketData="this.reportData" :isCSV="this.isCSV"
                                :file="this.file" v-else-if="repFormat.value === this.constants.reportType.market.value" />
            <new-valuation-report :dataId="this.myData.id" :valuationData="this.reportData"
                                  :isCSV="this.isCSV" :file="this.file"
                                  v-else-if="repFormat.value === this.constants.reportType.valuation.value" />
            <new-company-report :dataId="this.myData.id" :companyData="this.reportData" :isCSV="this.isCSV"
                                :file="this.file" v-else-if="repFormat.value === this.constants.reportType.company.value" />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="content benchmark"> -->
    <modal v-if="myDataModal" class="report_inputs my_data_body">
      <template slot="body">
        <button type="button" class="close_btn" @click="myDataModal = false">
          <md-icon>clear</md-icon>
        </button>
        <div class="modal_content">
          <PulseLoader :loading="isLoading" :class="{ hide: !isLoading }"
                       quote="Action is the foundational key to all success" author="Pablo Picasso"
                       profession="Spanish Painter" img="picasso.jpg"></PulseLoader>
          <my-data-table @get-load="getLoad" />
        </div>
      </template>
    </modal>
    <modal v-if="newInputsModal" @close="newInputsModal = false" class="report_inputs"
           :class="{ my_data_body: !isMyData }">
      <template slot="body">
        <button type="button" class="close_btn" @click="newInputsModal = false">
          <md-icon>clear</md-icon>
        </button>
        <div class="modal_content">
          <div v-if="isMyData">
            <h3 class="modal-title">Input Details</h3>
            <div class="field_grp">
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <md-field>
                    <label>Description*</label>
                    <md-input type="textarea" v-model="inputDescription" />
                    <validation-error :errors="apiValidationErrors.description" />
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100">
                  <md-field>
                    <label>Data Source*</label>
                    <md-input type="textarea" v-model="inputDataSource" />
                    <validation-error :errors="apiValidationErrors.description" />
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100">
                  <div class="text-center">
                    <md-button class="md-info md-round mb-4 md-theme-default" type="button"
                               @click="saveMyData()">
                      <i class="md-icon md-icon-font md-theme-default">check</i>
                      Select
                    </md-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <h3 v-if="this.repFormat.value !== this.constants.reportType.company.value" class="modal-title">
              Year Details</h3>
            <div v-if="this.repFormat.value !== this.constants.reportType.company.value" class="field_grp">
              <md-field>
                <label>Year*</label>
                <md-input type="text" v-model="createData.year"></md-input>
              </md-field>
            </div>
            <h4 v-if="incomeStatementLabel">Income Statement</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('income_statement')">
                <label>{{ item.label }}</label>
                <md-input v-model="createData[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <h4 v-if="balanceLabel">Balance Sheet</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('balance_sheet')">
                <label>{{ item.label }}</label>
                <md-input v-model="createData[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <h4 v-if="employmentLabel">Employment Data</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('employment')">
                <label>{{ item.label }}</label>
                <md-input v-model="createData[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <h4 v-if="liabilitiesLabel">Liabilities</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('liabilities')">
                <label>{{ item.label }}</label>
                <md-input v-model="createData[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <h4 v-if="otherLabel">Other</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('other')">
                <label>{{ item.label }}</label>
                <md-input v-model="createData[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <md-button v-if="this.repFormat.value !== this.constants.reportType.company.value"
                       class="md-info md-round" @click="addNewYear()">
              <md-icon>add</md-icon>Add another year
            </md-button>
            <md-button class="md-info md-round" @click="saveInputsData">
              <md-icon>save</md-icon>Finish
            </md-button>
          </div>
        </div>
      </template>
    </modal>
    <!-- </div> -->
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Modal, ValidationError, PulseLoader } from "@/components";
import moment from 'moment';
import formMixin from '@/mixins/form-mixin';
//Financial Report
import NewProfile from '../Profiles/NewProfile.vue';
//Market Report
import NewMarketProfile from '../Profiles/NewMarketProfile.vue';
//Valuation Report
import NewValuationReport from "../Profiles/NewValuationReport.vue";
//Company Report
import NewCompanyReport from "../Profiles/NewCompanyReport.vue";

import MyDataTable from "../Inputs/_partials/MyDataTable.vue";

import CreateReportFormatConstants from '@/helpers/constants/CreateReportFormatConstants.js';
import axios from 'axios';

export default {
  name: "CreateReportFormat",
  props: ['reportType'],
  components: {
    Modal,
    ValidationError,
    NewProfile,
    NewMarketProfile,
    NewValuationReport,
    NewCompanyReport,
    MyDataTable,
    PulseLoader,
  },
  mixins: [formMixin],
  data() {
    return {

      employmentLabel: false,
      balanceLabel: false,
      incomeStatementLabel: false,
      liabilitiesLabel: false,
      otherLabel: false,
      reportData: [],
      constants: CreateReportFormatConstants,
      reportInputs: [],
      isLoading: true,
      myDataModal: false,
      tableData: [],
      myData: { type: 'advanced', id: '' },
      newInputType: 'advanced',
      isMyData: true,
      inputDataSource: '',
      inputDescription: '',
      repCard: true,
      repType: false,
      repPara: false,
      newInputsModal: false,
      repFormat: '',
      hasData: false,
      inputData: null,
      paraData: false,
      createData: {},
      inputType: 'manual',
      isCSV: false,
      file: null,
      isFinancial: false,
      isMarket: false,
      isCompanyReport: false,
      isValuationReport: false,
    }
  },
  mounted() {
    if (this.paramReportType)
      this.checkReportType();

  },
  updated() {
    if ((this.subscriptions && this.subscriptions.length > 0) || this.isRetail)
      this.checkSubscriptions()
  },
  computed: {
    ...mapState({
      isRetail: (state) => (state.user.user_type.retail/* || state.user.allow_retail*/) ?true: null,
      subscriptions: (state) => state?.user?.user_subscriptions,
      isSubscriber: (state) => state.user.user_type.subscriber ?? null,
      myDataSelectedReport: (state) => state.selectedReportModule.myDataSelectedReport,
    }),
    paramReportType() {
      return this.$route.params.report;
    }
  },
  methods: {

    downloadFile(file) {
      axios.get(file, { responseType: 'blob' })
          .then(response => {
            const blob = new Blob([response.data], { type: 'text/csv' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'template.csv'
            link.click()
            URL.revokeObjectURL(link.href)
          }).catch()
    },
    checkSubscriptions: function () {
      if (this.isRetail) {
        this.isFinancial = true;
        this.isMarket = true;
        this.isCompanyReport = true;
        this.isValuationReport = true;
      } else {
        if (this.subscriptions.includes('usif') || this.subscriptions.includes('lif') || this.subscriptions.includes('usif_r') || this.subscriptions.includes('lif_r'))
          this.isFinancial = true;

        if (this.subscriptions.includes('usmr') || this.subscriptions.includes('lmr') || this.subscriptions.includes('usmr_r') || this.subscriptions.includes('lmr_r'))
          this.isMarket = true;

        if (this.subscriptions.includes('swot'))
          this.isCompanyReport = true;

        if (this.subscriptions.includes('vpro'))
          this.isValuationReport = true;

        if (this.paramReportType)
          switch (this.paramReportType) {
            case 'financial': if (!this.isFinancial)
              this.$router.push({ name: "Search" });
              break;
            case 'market': if (!this.isMarket)
              this.$router.push({ name: "Search" });
              break;
            case 'valuation': if (!this.isValuationReport)
              this.$router.push({ name: "Search" });
              break;
            case 'company': if (!this.isCompanyReport)
              this.$router.push({ name: "Search" });
              break;
          }
      }
    },
    checkReportType: function () {
      switch (this.paramReportType) {
        case 'financial': this.repCategory(this.constants.reportType.financial);
          break;
        case 'market': this.repCategory(this.constants.reportType.market);
          break;
        case 'valuation': this.repCategory(this.constants.reportType.valuation);
          break;
        case 'company': this.repCategory(this.constants.reportType.company);
          break;
      }
    },
    addNewYear: async function () {
      if (this.repFormat.value === this.constants.reportType.market.value) {
        if (this.createData.year === '2021')
          this.createData.year = 'Sep-2021'
      }

      let myDataId = this.myData.id;
      let createData = this.createData

      createData.myDataId = myDataId;

      this.reportData.push(createData);

      this.createData = {};
    },
    getLoad: function (e) {
      this.isLoading = e.isLoading;
    },
    getAllMyData: async function () {
      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );
      this.loaded = false;

      let params = {
        session_id: currentSession,
      };

      await this.$store.dispatch('myData/list', params).then((res) => {
        let myData = res.data.my_data;
        this.parseTableData(myData);
        this.loaded = true;
      });
    },
    parseTableData: async function (myData) {
      this.tableData = [];
      myData.forEach((data) => {
        this.tableData.push({
          id: data.id,
          dateCreated: moment(data.dateCreated).format('YYYY-MM-DD'),
          //client: data.user.firstName + ' ' + data.user.lastName,
          client: '',
          inputsType: data.type,
          search: '<md-icon>manage_search</md-icon>',
          dataSource: data.dataSource,
          description: data.description,
        });
      });
    },
    saveMyData: async function () {
      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );
      let params = {
        session_id: currentSession,
        type: this.newInputType,
        description: this.inputDescription,
        data_source: this.inputDataSource,
      };

      await this.$store.dispatch('myData/add', params).then((res) => {
        this.myData = res.data.my_data;
        this.isMyData = false;
        if (this.inputType === 'csv') {
          this.chooseInputFormat();
        }
        this.$store.dispatch('alerts/success', 'Data saved.');
      });
    },
    getInputList: function (type) {
      Object.filter = this.getObjectFilter();
      return Object.filter(this.reportInputs, el => el.section == type)
    },
    getObjectFilter: function () {
      return (obj, predicate) =>
          Object.keys(obj)
              .filter(key => predicate(obj[key]))
              .reduce((res, key) => (res[key] = obj[key], res), {});
    },
    repCategory: function (el) {

      this.repFormat = el;
      if (this.repFormat) {
        this.repCard = false;
        this.repType = true;
      }
      this.reportInputs = this.checkReport()

      this.employmentLabel = this.checkLabel('employment');
      this.balanceLabel = this.checkLabel('balance_sheet');
      this.incomeStatementLabel = this.checkLabel('income_statement');
      this.liabilitiesLabel = this.checkLabel('liabilities');
      this.otherLabel = this.checkLabel('other');
    },
    checkLabel: function (label) {
      return Object.entries(this.reportInputs).some(e => e.some(el => el.section === label))
    },
    checkReport: function () {
      switch (this.repFormat.value) {
        case this.constants.reportType.financial.value:
          return this.constants.financialReportInputs;

        case this.constants.reportType.market.value:
          return this.constants.marketReportInputs;

        case this.constants.reportType.company.value:
          return this.constants.companyReportInputs;

        case this.constants.reportType.valuation.value:
          return this.constants.valuationReportInputs;
      }
    },
    getMyData: function () {
      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );
      this.loaded = false;

      let params = {
        session_id: currentSession,
      };

      this.$store.dispatch('myData/list', params).then((res) => {
        if (res.data.my_data.length !== null) {
          this.myData = res.data.my_data[0];
          this.newInputsModal = true;
          this.isMyData = false;
        }
        else {
          this.newInputsModal = true;
        }
      });
    },
    inputsModal: function (type) {
      this.inputType = type;
      if (this.isRetail)
        this.getMyData();
      else {
        this.isMyData = true;
        this.newInputsModal = true;
      }

    },
    chooseInputFormat: function () {
      this.$refs.csvInput.click();
    },
    fileSelected: async function (event) {

      const files = event.target.files;
      let filename = files[0].name;
      if (filename) {
        this.inputData = filename;
      }
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      let file = files[0];

      this.file = file;

      this.uploadCSVFile(file);
    },
    uploadCSVFile: async function (file) {
      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );

      var form = new FormData();
      form.append('csv', file);
      form.append('type', this.myData.type);
      form.append('my_data_id', this.myData.id);
      form.append('session_id', currentSession);

      await this.$store.dispatch('myData/csv', form).then(async (res) => {

        if (res.data.csv_data) {
          switch (this.repFormat.value) {
            case this.constants.reportType.financial.value:
              await this.inputsCSVFinancialReport(res.data.csv_data);
              break;
            case this.constants.reportType.market.value:
              await this.inputsCSVMarketReport(res.data.csv_data);
              break;
            case this.constants.reportType.company.value:
              await this.inputsCSVCompanyReport(res.data.csv_data);
              break;
            case this.constants.reportType.valuation.value:
              await this.inputsCSVValuationReport(res.data.csv_data);
              break;
          }
          this.repType = false;
          this.repPara = true;
          this.hasData = true;
        } else {
          this.$store.dispatch('alerts/error', 'Invalid CSV data format!');
        }
      });
    },
    saveInputsData: async function () {
      if (this.repFormat.value === this.constants.reportType.company.value) {
        this.formatCreateDataCompany();
      }
      if (this.repFormat.value === this.constants.reportType.market.value) {
        if (this.createData.year === '2021')
          this.createData.year = 'Sep-2021'
      }

      this.newInputsModal = false;
      this.repType = false;
      this.repPara = true;
      this.hasData = true;

      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );
      let myDataId = this.myData.id;
      let type = this.myData.type;
      let createData = this.createData;
      createData.myDataId = myDataId;
      if (this.repFormat.value === this.constants.reportType.company.value) {
        createData.type = 'company';
        createData.session_id = currentSession;
        createData.profile_id = this.myData.id;
        this.reportData = createData;
      }
      else
        this.reportData.push(createData);


      let params = {
        type: type,
        session_id: currentSession,
        data: createData,
      };
      await this.$store.dispatch('year/add', params).then((res) => {
        this.$store.dispatch('alerts/success', 'Inputs created.');
      });
    },
    formatCreateDataCompany() {
      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );

      this.createData.type = 'company';
      this.createData.session_id = currentSession;
      this.createData.profile_id = this.myData.id

      this.createData.acc_receivable = this.createData['accountsReceivable'];
      this.createData.liability_accountsPayable = this.createData['accountsPayable'];
      this.createData.other_netSales = this.createData['annualSales'];
      this.createData.avg_annual_wage = this.createData['averageAnnualWage'];
      this.createData.asset_otherCurrent = this.createData['currentAssets'];
      this.createData.liability_otherCurrent = this.createData['otherCurrentLiabilities'];
      this.createData.other_amortization = this.createData['depreciation'];
      this.createData.ft_emps = this.createData['employment'];
      this.createData.other_grossProfit = this.createData['grossMargin'];
      this.createData.liability_longTermDebt = this.createData['totalLongTermLiabilities'];
      this.createData.other_offcomp = this.createData['officersComp'];
      this.createData.op_expenses = this.createData['operatingExpenses'];
      this.createData.net_profit = this.createData['preTaxNetProfit'];
      this.createData.asset_total = this.createData['totalAssets'];

    },
    getCSVData(csvData, row) {
      let data = csvData[row].slice(2, csvData[row].length)
      return this.formatCSVData(data, row)
    },

    formatCSVData(arrayData) {
      return arrayData.map(function (data, row) {
        if (data === 'Update Month')
          return 'Sep-2021';
        //row 3 = years
        else if ((data === 'undefined' || data === null) && row !== 3)
          return row;

        else if (typeof (data) === 'string')
          return parseInt(data.replace(/[^\w\s]/gi, ''))

        return data;
      });
    },
    inputsCSVMarketReport: async function (csvData) {
      this.isCSV = true;
      /**
       * Row Market CSV
       * 4 = years
       * 5 = annualSales
       * 6 = employment
       * 7 = averageAnnualWage
       * 8 = rent
       */
      let years = this.getCSVData(csvData, 4);
      let annualSales = this.getCSVData(csvData, 5);
      let employment = this.getCSVData(csvData, 6);
      let averageAnnualWage = this.getCSVData(csvData, 7);
      let rent = this.getCSVData(csvData, 8);
      this.reportData = [];
      for (let index = 0; index < years.length; index++) {
        this.createData = {};
        this.createData.year = years[index] ?? 0;
        this.createData.businessRevenue = annualSales[index] ?? 0;
        this.createData.employment = employment[index] ?? 0;
        this.createData.averageAnnualWage = averageAnnualWage[index] ?? 0;
        this.createData.rent = rent[index] ?? 0;

        if (this.createData.year === '2021')
          this.createData.year = 'Sep-2021'

        this.reportData.push(this.createData)
      }

    },
    inputsCSVValuationReport: async function (csvData) {

      this.isCSV = true;
      /**
       * Row Valuation CSV
       * 4 = years
       * 6 = businessRevenue
       * 7 = grossMargin
       * 8 = officersComp
       * 9 = preTaxNetProfit
       * 11 = depreciationOtherNonCashExpenses
       * 13 = operatingExpenses
       * 14 = interestExpense
       * 17 = accountsReceivable
       * 18 = totalCurrentAssets
       * 19 = totalAssets
       * 20 = accountsPayable
       * 21 = otherCurrentLiabilities
       * 22 = totalLongTermLiabilities
       * 24 = employment
       * 25 = averageAnnualWage
       */
      let years = this.getCSVData(csvData, 4);
      let businessRevenue = this.getCSVData(csvData, 5);
      let grossMargin = this.getCSVData(csvData, 6);
      let officersComp = this.getCSVData(csvData, 7);
      let depreciationOtherNonCashExpenses = this.getCSVData(csvData, 8);
      let ownerReplacementCompensation = this.getCSVData(csvData, 9);
      let preTaxNetProfit = this.getCSVData(csvData, 10);
      let incomeExpenseAddbacks = this.getCSVData(csvData, 11);


      let operatingExpenses = this.getCSVData(csvData, 12);
      let interestExpense = this.getCSVData(csvData, 13);
      let accountsReceivable = this.getCSVData(csvData, 14);
      let totalCurrentAssets = this.getCSVData(csvData, 15);
      let totalAssets = this.getCSVData(csvData, 16);
      let accountsPayable = this.getCSVData(csvData, 17);
      let otherCurrentLiabilities = this.getCSVData(csvData, 18);
      let totalLongTermLiabilities = this.getCSVData(csvData, 19);
      let employment = this.getCSVData(csvData, 20);
      let averageAnnualWage = this.getCSVData(csvData, 21);
      this.reportData = [];
      for (let index = 0; index < years.length; index++) {
        if (years[index] !== null) {
          this.createData = {};
          this.createData.year = years[index] ?? 0;
          this.createData.businessRevenue = businessRevenue[index] ?? 0;
          this.createData.grossMargin = grossMargin[index] ?? 0;
          this.createData.officersComp = officersComp[index] ?? 0;
          this.createData.preTaxNetProfit = preTaxNetProfit[index] ?? 0;
          this.createData.depreciation = depreciationOtherNonCashExpenses[index] ?? 0;
          this.createData.operatingExpenses = operatingExpenses[index] ?? 0;
          this.createData.interestExpense = interestExpense[index] ?? 0;
          this.createData.accountsReceivable = accountsReceivable[index] ?? 0;
          this.createData.currentAssets = totalCurrentAssets[index] ?? 0;
          this.createData.totalAssets = totalAssets[index] ?? 0;
          this.createData.accountsPayable = accountsPayable[index] ?? 0;
          this.createData.otherCurrentLiabilities = otherCurrentLiabilities[index] ?? 0;
          this.createData.totalLongTermLiabilities = totalLongTermLiabilities[index] ?? 0;
          this.createData.employment = employment[index] ?? 0;
          this.createData.averageAnnualWage = averageAnnualWage[index] ?? 0;
          this.createData.ownerReplacementCompensation = ownerReplacementCompensation[index] ?? 0;
          this.createData.incomeExpenseAddbacks = incomeExpenseAddbacks[index] ?? 0;

          this.reportData.push(this.createData)
        }
      }



    },
    inputsCSVFinancialReport: async function (csvData) {
      this.isCSV = true;
      /**
       * Row Valuation CSV
       * 4 = years
       * 6 = businessRevenue
       * 7 = costOfSalesLaborPortion
       * 8 = grossMargin
       * 9 = officersComp
       * 10 = salaryWages
       * 11 = rent
       * 12 = taxesPaid
       * 13 = advertising
       * 14 = benefitsPension
       * 15 = repairs
       * 16 = badDebt
       * 17 = salesGeneralAdminMisc
       * 18 = amortizationDepreciationDepletion
       * 19 = interestIncome
       * 20 = interestExpense
       * 21 = otherIncome
       * 22 = incomeTax
       * 25 = cash
       * 26 = receivables
       * 27 = inventory
       * 28 = otherCurrentAssets
       * 29 = grossFixedAssets
       * 30 = accumDepreciationAmortizationDepltn
       * 31 = netFixedAssets
       * 32 = otherNonCurrentAssets
       * 34 = accountsPayable
       * 35 = loansNotesPayable
       * 36 = otherCurrentLiabilities
       * 37 = totalLongTermLiabilities
       * 38 = employment
       * 39 = averageAnnualWage
       */
      let years = this.getCSVData(csvData, 4)
      let businessRevenue = this.getCSVData(csvData, 6);
      let costOfSalesLaborPortion = this.getCSVData(csvData, 7);
      let grossMargin = this.getCSVData(csvData, 8);
      let officersComp = this.getCSVData(csvData, 9);
      let salaryWages = this.getCSVData(csvData, 10);
      let rent = this.getCSVData(csvData, 11);
      let taxesPaid = this.getCSVData(csvData, 12);
      let advertising = this.getCSVData(csvData, 13);
      let benefitsPension = this.getCSVData(csvData, 14);
      let repairs = this.getCSVData(csvData, 15);
      let badDebt = this.getCSVData(csvData, 16);
      let salesGeneralAdminMisc = this.getCSVData(csvData, 17);
      let amortizationDepreciationDepletion = this.getCSVData(csvData, 18);
      let interestIncome = this.getCSVData(csvData, 19);
      let interestExpense = this.getCSVData(csvData, 20);
      let otherIncome = this.getCSVData(csvData, 21);
      let incomeTax = this.getCSVData(csvData, 22);
      let cash = this.getCSVData(csvData, 25);
      let receivables = this.getCSVData(csvData, 26);
      let inventory = this.getCSVData(csvData, 27);
      let otherCurrentAssets = this.getCSVData(csvData, 28);
      let grossFixedAssets = this.getCSVData(csvData, 29);
      let accumDepreciationAmortizationDepltn = this.getCSVData(csvData, 30);
      let netFixedAssets = this.getCSVData(csvData, 31);
      let otherNonCurrentAssets = this.getCSVData(csvData, 32);
      let accountsPayable = this.getCSVData(csvData, 34);
      let loansNotesPayable = this.getCSVData(csvData, 35);
      let otherCurrentLiabilities = this.getCSVData(csvData, 36);
      let totalLongTermLiabilities = this.getCSVData(csvData, 37);
      let employment = this.getCSVData(csvData, 38);
      let averageAnnualWage = this.getCSVData(csvData, 39);

      this.reportData = [];
      for (let index = 0; index < years.length; index++) {

        this.createData = {};
        this.createData.year = years[index];
        this.createData.grossMargin = grossMargin[index];
        this.createData.businessRevenue = businessRevenue[index];
        this.createData.costOfSalesLaborPortion = costOfSalesLaborPortion[index];
        this.createData.officersComp = officersComp[index];
        this.createData.salaryWages = salaryWages[index];
        this.createData.rent = rent[index];
        this.createData.taxesPaid = taxesPaid[index];
        this.createData.advertising = advertising[index];
        this.createData.benefitsPension = benefitsPension[index];
        this.createData.repairs = repairs[index];
        this.createData.badDebt = badDebt[index];
        this.createData.salesGeneralAdminMisc = salesGeneralAdminMisc[index];
        this.createData.amortizationDepreciationDepletion = amortizationDepreciationDepletion[index];
        this.createData.interestIncome = interestIncome[index];
        this.createData.interestExpense = interestExpense[index];
        this.createData.otherIncome = otherIncome[index];
        this.createData.incomeTax = incomeTax[index];
        this.createData.cash = cash[index];
        this.createData.receivables = receivables[index];
        this.createData.inventory = inventory[index];
        this.createData.otherCurrentAssets = otherCurrentAssets[index];
        this.createData.grossFixedAssets = grossFixedAssets[index];
        this.createData.accumDepreciationAmortizationDepltn = accumDepreciationAmortizationDepltn[index];
        this.createData.netFixedAssets = netFixedAssets[index];
        this.createData.otherNonCurrentAssets = otherNonCurrentAssets[index];
        this.createData.accountsPayable = accountsPayable[index];
        this.createData.loansNotesPayable = loansNotesPayable[index];
        this.createData.otherCurrentLiabilities = otherCurrentLiabilities[index];
        this.createData.totalLongTermLiabilities = totalLongTermLiabilities[index];
        this.createData.employment = employment[index];
        this.createData.averageAnnualWage = averageAnnualWage[index];

        this.reportData.push(this.createData);


      }

    },
    inputsCSVCompanyReport: async function (csvData) {
      this.isCSV = true;

      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );
      /**
       * Row Company CSV
       * 5 = annualSales
       * 6 = grossMargin
       * 7 = officersComp
       * 8 = depreciation
       * 9 = operatingExpenses
       * 10 = preTaxNetProfit
       * 15 = accountsReceivable
       * 16 = currentAssets
       * 17 = totalAssets
       * 18 = accountsPayable
       * 19 = otherCurrentLiabilities
       * 20 = totalLongTermLiabilities
       * 22 = employment
       * 23 = averageAnnualWage
       */

      let annualSales = this.getCSVData(csvData, 5);
      let grossMargin = this.getCSVData(csvData, 6);
      let officersComp = this.getCSVData(csvData, 7);
      let depreciation = this.getCSVData(csvData, 8);
      let operatingExpenses = this.getCSVData(csvData, 9);
      let preTaxNetProfit = this.getCSVData(csvData, 10);
      let accountsReceivable = this.getCSVData(csvData, 15);
      let currentAssets = this.getCSVData(csvData, 16);
      let totalAssets = this.getCSVData(csvData, 17);
      let accountsPayable = this.getCSVData(csvData, 18);
      let otherCurrentLiabilities = this.getCSVData(csvData, 19);
      let totalLongTermLiabilities = this.getCSVData(csvData, 20);
      let employment = this.getCSVData(csvData, 22);
      let averageAnnualWage = this.getCSVData(csvData, 23);

      this.createData = {};

      this.createData.type = 'company';
      this.createData.session_id = currentSession;
      this.createData.profile_id = this.myData.id;
      this.createData.acc_receivable = accountsReceivable[0] + '';
      this.createData.liability_accountsPayable = accountsPayable[0] + '';
      this.createData.other_netSales = annualSales[0] + '';
      this.createData.avg_annual_wage = averageAnnualWage[0] + '';
      this.createData.asset_otherCurrent = currentAssets[0] + '';
      this.createData.liability_otherCurrent = otherCurrentLiabilities[0] + '';
      this.createData.other_amortization = depreciation[0] + '';
      this.createData.ft_emps = employment[0] + '';
      this.createData.other_grossProfit = grossMargin[0] + '';
      this.createData.liability_longTermDebt = totalLongTermLiabilities[0] + '';
      this.createData.other_offcomp = officersComp[0] + '';
      this.createData.op_expenses = operatingExpenses[0] + '';
      this.createData.net_profit = preTaxNetProfit[0] + '';
      this.createData.asset_total = totalAssets[0] + '';

      this.reportData = this.createData;

    },
    financialData: function (years, myData) {
      this.reportData = [];
      let yearsAux = [];

      const releaseYears = this.$store.getters['ifRelease/years'] || [];

      releaseYears.forEach(y => {
          let pushed = false;
          years.forEach(el => {
            if(el.year == y) {
              yearsAux.push(el);
              pushed = true;
            }
          });

          if(!pushed) { yearsAux.push(this.defaultInputs(y)); }
      });

      let i = 0;
      yearsAux.forEach(element => {
        delete element.id;

        this.createData = element;

        this.createData['year'] = releaseYears[i];

        this.myData.type = myData.type;
        this.myData.id = myData.id;
        this.reportData.push(this.createData);
        i++;
      });

      this.repType = false;
      this.repPara = true;
      this.hasData = true;
      this.myDataModal = false;
    },
    marketData: function (years, myData) {
      this.reportData = [];
      let yearsAux = [];

      // Iterate the actual IMR release-year LABELS (e.g. 2023, 2024, 2025, Jan-2026)
      // rather than walking four consecutive calendar integers. The TTM slot's label is a
      // month-year string ("Jan-2026"), so the old integer walk (..., 2026) never matched
      // it: the 4th input row always fell back to empty defaults and any saved TTM value
      // failed to prefill. Mirrors financialData() above.
      const releaseYears = this.$store.getters['imrRelease/years'] || [];

      releaseYears.forEach(y => {
        let pushed = false;
        years.forEach(el => {
          if(el.year == y) {
            yearsAux.push(el);
            pushed = true;
          }
        });

        if(!pushed) { yearsAux.push(this.defaultInputs(y)); }
      });

      /*switch (years.length) {
        case 1: yearsAux.push(this.defaultInputs('2019'));
          yearsAux.push(this.defaultInputs('2020'));
          yearsAux.push(this.defaultInputs('2021'));
          yearsAux.push(years[0]);
          break;

        case 2: yearsAux.push(this.defaultInputs('2019'));
          yearsAux.push(this.defaultInputs('2020'));
          yearsAux.push(years[0]);
          yearsAux.push(years[1]);
          break;
        case 3: yearsAux.push(this.defaultInputs('2019'));
          yearsAux.push(years[0]);
          yearsAux.push(years[1]);
          yearsAux.push(years[2]);
          break;
        case 4: yearsAux = years;
          break;
        default:
          yearsAux.push(years[years.length - 4])
          yearsAux.push(years[years.length - 3])
          yearsAux.push(years[years.length - 2])
          yearsAux.push(years[years.length - 1])
          break;
      }*/

      let i = 0;
      yearsAux.forEach(element => {
        this.createData = {};

        // i must increment: getYearByIndex(i,'market') is the per-slot label. Without the
        // increment (the prior bug) every row was stamped with year index 0, so all four
        // input rows claimed to be the first year and the later years - including the TTM
        // slot - could never be entered or saved correctly.
        this.createData.year = this.getYearByIndex(i, 'market');
        this.createData.businessRevenue = element.businessRevenue;
        this.createData.employment = element.employment;
        this.createData.averageAnnualWage = element.averageAnnualWage;
        this.createData.rent = element.rent;

        this.myData.type = myData.type;
        this.myData.id = myData.id;

        this.reportData.push(this.createData);
        i++;
      });

      this.repType = false;
      this.repPara = true;
      this.hasData = true;

      this.myDataModal = false;
    },
    companyData: function (years, myData) {
      let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
      );
      let lastYear = Object.values(years).pop()
      this.myData.type = myData.type;
      this.myData.id = myData.id;

      this.createData.type = 'company';
      this.createData.session_id = currentSession;
      this.createData.profile_id = this.myData.id;
      this.createData.acc_receivable = lastYear.receivables;
      this.createData.other_netSales = lastYear.businessRevenue;
      this.createData.other_grossProfit = lastYear.grossMargin;
      this.createData.other_offcomp = lastYear.officersComp;
      this.createData.other_amortization = lastYear.amortizationDepreciationDepletion;
      this.createData.avg_annual_wage = lastYear.averageAnnualWage;
      this.createData.ft_emps = lastYear.employment;
      this.createData.liability_accountsPayable = lastYear.accountsPayable;
      this.createData.liability_otherCurrent = lastYear.accountsPayable + lastYear.loansNotesPayable + lastYear.otherCurrentLiabilities;
      this.createData.liability_longTermDebt = lastYear.totalLongTermLiabilities;
      this.createData.asset_otherCurrent = lastYear.cash + lastYear.receivables + lastYear.inventory + lastYear.otherCurrentAssets;
      this.createData.totalAssets = lastYear.cash + lastYear.receivables + lastYear.inventory + lastYear.otherCurrentAssets + lastYear.netFixedAssets + lastYear.otherNonCurrentAssets;

      this.createData.op_expenses = lastYear.officersComp + lastYear.salaryWages + lastYear.rent + lastYear.taxesPaid + lastYear.advertising + lastYear.benefitsPension + lastYear.repairs +
          lastYear.badDebt + lastYear.salesGeneralAdminMisc + lastYear.amortizationDepreciationDepletion;

      this.createData.net_profit = lastYear.grossMargin - lastYear.officersComp - lastYear.salaryWages - lastYear.rent - lastYear.taxesPaid - lastYear.advertising - lastYear.benefitsPension -
          lastYear.repairs - lastYear.badDebt - lastYear.salesGeneralAdminMisc - lastYear.amortizationDepreciationDepletion + lastYear.interestIncome - lastYear.interestExpense + lastYear.otherIncome;

      this.reportData = this.createData;
      this.repType = false;
      this.repPara = true;
      this.hasData = true;

      this.myDataModal = false;
    },
    defaultInputs: function (year){
      return {
        businessRevenue: 0,
        repairs: 0,
        salesGeneralAdminMisc: 0,
        badDebt: 0,
        otherIncome: 0,
        benefitsPension: 0,
        advertising: 0,
        grossMargin: 0,
        year: year,
        officersComp: 0,
        preTaxNetProfit: 0,
        salaryWages: 0,
        rent: 0,
        taxesPaid: 0,
        interestIncome: 0,
        asset_otherCurrent: 0,
        accumDepreciationAmortizationDepltn: 0,
        netFixedAssets: 0,
        inventory: 0,
        receivables: 0,
        cash: 0,
        otherCurrentAssets: 0,
        otherNonCurrentAssets: 0,
        otherCurrentLiabilities: 0,
        accountsPayable: 0,
        averageAnnualWage: 0,
        loansNotesPayable: 0,
        totalLongTermLiabilities: 0,
        employment: 0,
        interestExpense: 0,
        amortizationDepreciationDepletion: 0,
      }
    },
    getYearByIndex: function (index, report) {
      switch (report) {
        case 'valuation':
          switch (index) {
            case 0: return '2023'; // TODO: make this automatic.
            case 1: return '2024'; // TODO: make this automatic.
            case 2: return '2025'; // TODO: make this automatic.
          }
          break;
        case 'market':
          return this.$store.getters['imrRelease/yearAt'](index);
        case 'financial':
          return this.$store.getters['ifRelease/yearAt'](index);
        case 'company':
          switch (index) {
            case 0: return '2020'; // TODO: make this automatic.
          }
          break;
      }
    },
    valuationData: async function (years, myData) {

      let yearsAux = [];


      let startingYear = this.getYearByIndex(0, 'valuation'); // TODO! // TODO: make this automatic.
      let yearsTotal = 3; // TODO! // TODO: make this automatic.
      let endingYear = parseInt(startingYear) + parseInt(yearsTotal);

      for(let y = startingYear; y < endingYear; ++y) {
        let pushed = false;
        years.forEach(el => {
          if(el.year == y) {
            yearsAux.push(el);
            pushed = true;
          }
        });

        if(!pushed) { yearsAux.push(this.defaultInputs(y)); }
      }

      /*switch (years.length) {
        case 1: yearsAux.push(this.defaultInputs('2019'));
          yearsAux.push(this.defaultInputs('2020'));
          yearsAux.push(years[0]);
          break;

        case 2: yearsAux.push(this.defaultInputs('2019'));
          yearsAux.push(years[0]);
          yearsAux.push(years[1]);
          break;
        case 3: yearsAux = years;
          break;
        default:
          yearsAux.push(years[years.length - 3])
          yearsAux.push(years[years.length - 2])
          yearsAux.push(years[years.length - 1])
          break;
      }*/

      let i = 0;
      yearsAux.forEach(lastYear => {
        this.createData = {};
        this.createData.businessRevenue = lastYear.businessRevenue;
        this.createData.grossMargin = lastYear.grossMargin;
        this.createData.officersComp = lastYear.officersComp;
        this.createData.preTaxNetProfit = lastYear.grossMargin - lastYear.officersComp - lastYear.salaryWages - lastYear.rent - lastYear.taxesPaid - lastYear.advertising - lastYear.benefitsPension -
            lastYear.repairs - lastYear.badDebt - lastYear.salesGeneralAdminMisc - lastYear.amortizationDepreciationDepletion + lastYear.interestIncome - lastYear.interestExpense + lastYear.otherIncome;
        this.createData.operatingExpenses = lastYear.officersComp + lastYear.salaryWages + lastYear.rent + lastYear.taxesPaid + lastYear.advertising + lastYear.benefitsPension + lastYear.repairs +
            lastYear.badDebt + lastYear.salesGeneralAdminMisc + lastYear.amortizationDepreciationDepletion;
        this.createData.accountsReceivable = lastYear.receivables;
        this.createData.currentAssets = lastYear.cash + lastYear.receivables + lastYear.inventory + lastYear.otherCurrentAssets;
        this.createData.totalAssets = lastYear.cash + lastYear.receivables + lastYear.inventory + lastYear.otherCurrentAssets + lastYear.netFixedAssets + lastYear.otherNonCurrentAssets;
        this.createData.accountsPayable = lastYear.accountsPayable;
        this.createData.otherCurrentLiabilities = lastYear.accountsPayable + lastYear.loansNotesPayable + lastYear.otherCurrentLiabilities;
        this.createData.totalLongTermLiabilities = lastYear.totalLongTermLiabilities;
        this.createData.averageAnnualWage = lastYear.averageAnnualWage;
        this.createData.employment = lastYear.employment;
        this.createData.depreciation = lastYear.amortizationDepreciationDepletion;
        this.createData.ownerReplacementCompensation = 0;
        this.createData.interestExpense = lastYear.interestExpense;
        this.createData.year = this.getYearByIndex(i, 'valuation');
        this.myData.type = myData.type;
        this.myData.id = myData.id;
        this.reportData.push(this.createData);
        i++;
      });

      this.repType = false;
      this.repPara = true;
      this.hasData = true;

      this.myDataModal = false;
    }
  },

  async created() {
    await this.getAllMyData();
    await this.$store.dispatch('ifRelease/fetchIfReleaseYears');
    await this.$store.dispatch('imrRelease/fetchImrReleaseYears');
  },
  watch: {
    paramReportType(newValue, oldValue) {
      this.checkReportType();
    },
    subscriptions() {
      if ((this.subscriptions && this.subscriptions.length > 0) || this.isRetail)
        this.checkSubscriptions()
    },
    myDataSelectedReport() {
      if (this.myDataSelectedReport) {
        const { myData, years } = this.myDataSelectedReport;
        switch (this.repFormat.value) {
          case this.constants.reportType.financial.value:
            this.financialData(years, myData); break;

          case this.constants.reportType.market.value:
            this.marketData(years, myData); break;

          case this.constants.reportType.company.value:
            this.companyData(years, myData); break;

          case this.constants.reportType.valuation.value:
            this.valuationData(years, myData); break;
        }
      }
    }
  }
}
</script>